import { Outlet } from 'react-router'

import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { T } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'

export function AddonRoute() {
  return <Outlet />
}

export function AddonBreadCrumb() {
  const { Link } = useRouter()
  return (
    <Link href={adminRoutes.appStore.addons.root}>
      <T id="Generics.Addons" defaultMessage="Add-ons" />
    </Link>
  )
}
